module.exports = __webpack_public_path__ + "static/media/title.9039ba39.png";